import React, {CSSProperties, FC} from "react";
import {grey} from "@material-ui/core/colors";

type Props = {
  style?: CSSProperties;
};

type NavIconProps = {
  style?: CSSProperties;
  path: string;
};

const NavIcon: FC<NavIconProps> = ({style, path}) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d={path} fill={style?.color || grey[600]} />
  </svg>
);

export const ExhibitorsIcon: FC<Props> = ({style}) => (
  <NavIcon
    style={style}
    path="M12 7V3H2V21H22V7H12ZM6 19H4V17H6V19ZM6 15H4V13H6V15ZM6 11H4V9H6V11ZM6 7H4V5H6V7ZM10 19H8V17H10V19ZM10 15H8V13H10V15ZM10 11H8V9H10V11ZM10 7H8V5H10V7ZM20 19H12V17H14V15H12V13H14V11H12V9H20V19ZM18 11H16V13H18V11ZM18 15H16V17H18V15Z"
  />
);

export const CustomReportIcon: FC<Props> = ({style}) => (
  <NavIcon
    style={style}
    path="M2 0H16C16.5304 0 17.0391 0.210714 17.4142 0.585786C17.7893 0.960859 18 1.46957 18 2V14C18 14.5304 17.7893 15.0391 17.4142 15.4142C17.0391 15.7893 16.5304 16 16 16H2C1.46957 16 0.960859 15.7893 0.585786 15.4142C0.210714 15.0391 0 14.5304 0 14V2C0 1.46957 0.210714 0.960859 0.585786 0.585786C0.960859 0.210714 1.46957 0 2 0ZM2 4V8H8V4H2ZM10 4V8H16V4H10ZM2 10V14H8V10H2ZM10 10V14H16V10H10Z"
  />
);

export const BackButtonIcon: FC<Props> = ({style}) => (
  <NavIcon
    style={style}
    path="M21 11H6.83L10.41 7.41L9 6L3 12L9 18L10.41 16.59L6.83 13H21V11Z"
  />
);

export const TaskReviewIcon: FC<Props> = ({style}) => (
  <NavIcon
    style={style}
    path="M22 5.18L10.59 16.6L6.35 12.36L7.76 10.95L10.59 13.78L20.59 3.78L22 5.18ZM19.79 10.22C19.92 10.79 20 11.39 20 12C20 16.42 16.42 20 12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C13.58 4 15.04 4.46 16.28 5.25L17.72 3.81C16.1 2.67 14.13 2 12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 10.81 21.78 9.67 21.4 8.61L19.79 10.22Z"
  />
);

export const DashboardIcon: FC<Props> = ({style}) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 6V20H6V22H20C21.1 22 22 21.1 22 20V6H20Z"
      fill={style?.color || grey[600]}
    />
    <path
      d="M16 2H4C2.9 2 2 2.9 2 4V16C2 17.1 2.9 18 4 18H16C17.1 18 18 17.1 18 16V4C18 2.9 17.1 2 16 2ZM9 16H4V11H9V16ZM16 16H11V11H16V16ZM16 9H4V4H16V9Z"
      fill={style?.color || grey[600]}
    />
  </svg>
);
export const ShoppingIcon: FC<Props> = ({style}) => (
  <NavIcon
    style={style}
    path="M18 6H16C16 3.79 14.21 2 12 2C9.79 2 8 3.79 8 6H6C4.9 6 4 6.9 4 8V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8C20 6.9 19.1 6 18 6ZM10 10C10 10.55 9.55 11 9 11C8.45 11 8 10.55 8 10V8H10V10ZM12 4C13.1 4 14 4.9 14 6H10C10 4.9 10.9 4 12 4ZM16 10C16 10.55 15.55 11 15 11C14.45 11 14 10.55 14 10V8H16V10Z"
  />
);

export const OnlineManualIcon: FC<Props> = ({style}) => (
  <NavIcon
    style={style}
    path="M18 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V4C20 2.9 19.1 2 18 2ZM6 4H11V12L8.5 10.5L6 12V4Z"
  />
);

export const OrdersIcon: FC<Props> = ({style}) => (
  <NavIcon
    style={style}
    path="M18 17H6V15H18V17ZM18 13H6V11H18V13ZM18 9H6V7H18V9ZM3 22L4.5 20.5L6 22L7.5 20.5L9 22L10.5 20.5L12 22L13.5 20.5L15 22L16.5 20.5L18 22L19.5 20.5L21 22V2L19.5 3.5L18 2L16.5 3.5L15 2L13.5 3.5L12 2L10.5 3.5L9 2L7.5 3.5L6 2L4.5 3.5L3 2V22Z"
  />
);

export const SuppliersIcon: FC<Props> = ({style}) => (
  <NavIcon
    style={style}
    path="M20 4H4V6H20V4ZM21 14V12L20 7H4L3 12V14H4V20H14V14H18V20H20V14H21ZM12 18H6V14H12V18Z"
  />
);

export const PackagesIcon: FC<Props> = ({style}) => (
  <NavIcon
    style={style}
    path="M20 2H4C3 2 2 2.9 2 4V7.01C2 7.73 2.43 8.35 3 8.7V20C3 21.1 4.1 22 5 22H19C19.9 22 21 21.1 21 20V8.7C21.57 8.35 22 7.73 22 7.01V4C22 2.9 21 2 20 2ZM15 14H9V12H15V14ZM20 7H4V4L20 3.98V7Z"
  />
);

export const ActivityFeedIcon: FC<Props> = ({style}) => (
  <NavIcon
    style={style}
    path="M13 3C8.03 3 4 7.03 4 12H1L4.89 15.89L4.96 16.03L9 12H6C6 8.13 9.13 5 13 5C16.87 5 20 8.13 20 12C20 15.87 16.87 19 13 19C11.07 19 9.32 18.21 8.06 16.94L6.64 18.36C8.27 19.99 10.51 21 13 21C17.97 21 22 16.97 22 12C22 7.03 17.97 3 13 3ZM12 8V13L16.28 15.54L17 14.33L13.5 12.25V8H12Z"
  />
);

export const GlossaryIcon: FC<Props> = ({style}) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 10.76C19.23 10.59 18.38 10.5 17.5 10.5C15.7 10.5 14.13 10.85 13 11.49V9.83C14.26 9.29 15.8 9 17.5 9C18.36 9 19.21 9.09 20 9.24V10.76Z"
      fill={style?.color || grey[600]}
    />
    <path
      d="M13 12.49V14.15C14.13 13.51 15.7 13.16 17.5 13.16C18.38 13.16 19.23 13.25 20 13.42V11.9C19.21 11.75 18.36 11.66 17.5 11.66C15.8 11.66 14.26 11.96 13 12.49Z"
      fill={style?.color || grey[600]}
    />
    <path
      d="M13 15.16C14.26 14.62 15.8 14.33 17.5 14.33C18.36 14.33 19.21 14.41 20 14.57V16.09C19.23 15.92 18.38 15.83 17.5 15.83C15.7 15.83 14.13 16.18 13 16.82V15.16Z"
      fill={style?.color || grey[600]}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.5 4.5C18.67 4.5 19.89 4.65 21 5C21.75 5.25 22.4 5.55 23 6V20.6C23 20.85 22.75 21.1 22.5 21.1C22.4 21.1 22.35 21.1 22.25 21.05C20.85 20.3 19.15 20 17.5 20C15.8 20 13.35 20.65 12 21.5C10.55 20.4 8.45 20 6.5 20C5.05 20 3.1 20.45 1.75 21.1C1.7 21.1 1.6625 21.1125 1.625 21.125C1.5875 21.1375 1.55 21.15 1.5 21.15C1.25 21.15 1 20.9 1 20.65V6C2.45 4.9 4.55 4.5 6.5 4.5C8.45 4.5 10.55 4.9 12 6C13.45 4.9 15.55 4.5 17.5 4.5ZM17.5 18C18.7 18 19.9 18.15 21 18.5V7C19.9 6.65 18.7 6.5 17.5 6.5C15.8 6.5 13.35 7.15 12 8V19.5C13.35 18.65 15.8 18 17.5 18Z"
      fill={style?.color || grey[600]}
    />
  </svg>
);

export const AccessIcon: FC<Props> = ({style}) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 17L12 14.06C11.61 14.02 11.32 14 11 14C8.33 14 3 15.34 3 18V20H12L9 17ZM11 12C13.21 12 15 10.21 15 8C15 5.79 13.21 4 11 4C8.79 4 7 5.79 7 8C7 10.21 8.79 12 11 12Z"
      fill={style?.color || grey[600]}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.47 20.5L12 17L13.4 15.59L15.47 17.67L20.6 12.5L22 13.91L15.47 20.5Z"
      fill={style?.color || grey[600]}
    />
  </svg>
);
